import { apiGet, apiPost, unwrap } from './apiClient';
import { ResponseDTO, LdapUserDTO, UserDTO, BulkLdapUserCreationRequestDTO } from '@/types/api';

const BASE = '/api/v1/ldap-users';

export async function getLdapUserByEmail(email: string): Promise<UserDTO> {
  const res = await apiGet<ResponseDTO<UserDTO>>(`${BASE}/user`, { params: { email } });
  return unwrap(res);
}

export async function getLdapUserById(id: string): Promise<LdapUserDTO> {
  const res = await apiGet<ResponseDTO<LdapUserDTO>>(`${BASE}/${id}`);
  return unwrap(res);
}

export async function searchRemoteLdapUsers(ldapSettingId: string, query: string): Promise<LdapUserDTO[]> {
  const res = await apiGet<ResponseDTO<LdapUserDTO[]>>(`${BASE}/search/${ldapSettingId}`, { params: { query } });
  return unwrap(res);
}

export async function bulkCreateLdapUsers(request: BulkLdapUserCreationRequestDTO): Promise<string> {
  const res = await apiPost<ResponseDTO<string>>(`${BASE}/addusers`, request);
  return unwrap(res);
}
